import axios from 'axios';
import { BASE_URL } from '../utils';

export function getAdminHeaders() {
  const token = localStorage.getItem('cognitoAccessToken') || localStorage.getItem('sessionToken');
  const idToken = localStorage.getItem('cognitoIdToken');
  const headers = { Authorization: `Bearer ${token}` };
  if (idToken) headers['x-id-token'] = idToken;
  return headers;
}

export const adminApi = {
  get: (path) => axios.get(`${BASE_URL}${path}`, { headers: getAdminHeaders() }),
  post: (path, data) => axios.post(`${BASE_URL}${path}`, data, { headers: getAdminHeaders() }),
  put: (path, data) => axios.put(`${BASE_URL}${path}`, data, { headers: getAdminHeaders() }),
  delete: (path) => axios.delete(`${BASE_URL}${path}`, { headers: getAdminHeaders() }),
};
